import Encryptor from "@/core/service/Encryptor";

export class SecureLocalStorageManager {

    static async setValue(name: string, value: string) {
        const encrypted = await Encryptor.encrypt(value);
        localStorage.setItem(name, encrypted);
    }

    static async getValue(name: string): Promise<string | null> {
        try {
            const encrypted = localStorage.getItem(name);
            if (encrypted === null)
                return null;
            return await Encryptor.decrypt(encrypted);
        } catch (e) {
            console.error('Decryption failed:', e);
            return null;
        }
    }

}
